import { render, staticRenderFns } from "./ChooseCampaign.vue?vue&type=template&id=bc2042a8&"
import script from "./ChooseCampaign.vue?vue&type=script&lang=js&"
export * from "./ChooseCampaign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports